
// returns an array containing the ids of the position of the banners
// the first banner always has id = 1

export function getBannersIdxByEventsCount(options: {
  eventsCount: number,
  bannersCount: number
}): number[] {
  const occupiedItems: number = 2
  const freeItems: number = (options.eventsCount + options.bannersCount) - occupiedItems
  let bannersIdx: number[] = []
  if (options.bannersCount) {
    bannersIdx = [1]
    for (let i = 1; i < options.bannersCount; i++) {
      const id: number = Math.floor((freeItems / options.bannersCount) * i)
      bannersIdx.push(id + occupiedItems)
    }
  }
  return bannersIdx
}
